module.exports = __webpack_public_path__ + "img/Emirates-logo.ac883121.png";